"use client";

import React from "react";
import YouTube, { YouTubeProps } from "react-youtube";

export default function YoutubeVideo({
  YTid,
  heading,
  subheading,
  options,
}: {
  YTid: string;
  heading?: string;
  subheading?: string;
  options?: YouTubeProps["opts"];
}) {
  const onPlayerReady: YouTubeProps["onReady"] = () => {
    //event.target.pauseVideo();
  };

  const opts: YouTubeProps["opts"] = options || {
    host: "https://www.youtube-nocookie.com",
    playerVars: {
      controls: 0,
      fs: 0,
      iv_load_policy: 3,
      rel: 0,
      // https://developers.google.com/youtube/player_parameters
      autoplay: 0,
    },
  };

  return (
    <div className="relative w-full max-w-[960px] text-center">
      {heading && <h2 className="my-5">{heading}</h2>}
      {subheading && <p className="my-5">{subheading}</p>}
      <YouTube
        className="w-full relative pb-[56.25%] h-0 rounded-[30px] overflow-hidden bg-primary-black [&_iFrame]:w-full [&_iFrame]:h-full [&_iFrame]:absolute [&_iFrame]:top-0 [&_iFrame]:left-0"
        videoId={YTid}
        opts={opts}
        onReady={onPlayerReady}
      />
    </div>
  );
}
